import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import AdminLayout from './components/layouts/AdminLayout';
import PublicLayout from './components/layouts/PublicLayout';

// Public Pages
import LandingPage from './pages/public/LandingPage';
import StorePage from './pages/public/StorePage';
import ProductDetailPage from './pages/public/ProductDetailPage';
import CheckoutPage from './pages/public/CheckoutPage';

// Auth Page
import LoginPage from './pages/LoginPage';

// Admin Pages
import DashboardPage from './pages/admin/DashboardPage';
import WorkshopPage from './pages/admin/WorkshopPage';
import OrdersPage from './pages/admin/OrdersPage';
import CustomersPage from './pages/admin/CustomersPage';
import InventoryPage from './pages/admin/InventoryPage';
import ExpensesPage from './pages/admin/ExpensesPage';
import PrintersPage from './pages/admin/PrintersPage';
import CostCalculatorPage from './pages/admin/CostCalculatorPage';
import GeneratorPage from './pages/admin/GeneratorPage';
import CookieCutterPage from './pages/admin/CookieCutterPage';
import BoxGeneratorPage from './pages/admin/BoxGeneratorPage';
import LithophanePage from './pages/admin/LithophanePage';
import ProductsAdminPage from './pages/admin/ProductsAdminPage';
import AddProductPageAdmin from './pages/admin/AddProductPageAdmin';
import ProductDetailPageAdmin from './pages/admin/ProductDetailPageAdmin';
import OrderDetailPageAdmin from './pages/admin/OrderDetailPageAdmin';
import ToolsHubPage from './pages/admin/ToolsHubPage';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();
  if (isLoading) return <div className="h-screen w-screen flex items-center justify-center bg-background text-foreground">Cargando...</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<LandingPage />} />
        <Route path="/tienda" element={<StorePage />} />
        <Route path="/tienda/:slug" element={<ProductDetailPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
      </Route>

      {/* Auth Route */}
      <Route path="/login" element={<LoginPage />} />

      {/* Admin Routes */}
      <Route
        element={
          <ProtectedRoute>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/workshop" element={<WorkshopPage />} />
        <Route path="/orders" element={<OrdersPage />} />
        <Route path="/orders/detail" element={<OrderDetailPageAdmin />} />
        <Route path="/orders/:id" element={<OrderDetailPageAdmin />} />
        <Route path="/customers" element={<CustomersPage />} />
        <Route path="/inventory" element={<InventoryPage />} />
        <Route path="/filaments" element={<InventoryPage defaultTab="filaments" />} />
        <Route path="/expenses" element={<ExpensesPage />} />
        <Route path="/printers" element={<PrintersPage />} />
        <Route path="/calculator" element={<CostCalculatorPage />} />
        <Route path="/tools" element={<ToolsHubPage />} />
        <Route path="/generator" element={<Navigate to="/tools" replace />} />
        <Route path="/tools/lamp-generator" element={<GeneratorPage />} />
        <Route path="/tools/cookie-cutter" element={<CookieCutterPage />} />
        <Route path="/tools/box-generator" element={<BoxGeneratorPage />} />
        <Route path="/tools/lithophane" element={<LithophanePage />} />
        <Route path="/products-admin" element={<ProductsAdminPage />} />
        <Route path="/products-admin/new" element={<AddProductPageAdmin />} />
        <Route path="/products-admin/detail" element={<ProductDetailPageAdmin />} />
        <Route path="/products-admin/:id" element={<ProductDetailPageAdmin />} />
        <Route path="/settings" element={<div>Settings - TBD</div>} />
      </Route>

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
